import { Nullable } from "src/shared/utils/typescript";

const ZERO_WIDTH_CHARACTERS = /[\u200B-\u200D\uFEFF]/g;
const UNICODE_DASHES = /[\u2010-\u2015\u2212]/g;
const UNICODE_APOSTROPHES = /[\u2018\u2019\u02BC]/g;

export const normalizeLegalName = (value: Nullable<string>) =>
  (value ?? "")
    .normalize("NFKC")
    .replace(ZERO_WIDTH_CHARACTERS, "")
    .replace(UNICODE_DASHES, "-")
    .replace(UNICODE_APOSTROPHES, "'")
    .replace(/\s+/g, " ")
    .trim()
    .toLocaleLowerCase("en-CA");

export const doLegalNamesMatch = (
  signature: Nullable<string>,
  legalName: Nullable<string>
) => {
  const normalizedSignature = normalizeLegalName(signature);
  return (
    normalizedSignature.length > 0 &&
    normalizedSignature === normalizeLegalName(legalName)
  );
};
